import React, {PureComponent} from "react"
import {Row} from "react-bootstrap"

import Flex from "@irati/ui/src/Flex"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import {OrganisationalSummaryCategory, PaymentCurrencyType} from "@irati/types"
import FilterChipToggle from "@irati/ui/src/FilterChipToggle"
import {IconTypes} from "@irati/ui/src/Icon"
import {Select} from "@irati/ui/src/FormItem"
import Divider from "@irati/ui/src/Divider"

import theme from "@irati/ui/src/global/theme"

interface Props extends InjectIntl {
  id?: string,
  trendRates: TrendRate[],
  onChange: (category: OrganisationalSummaryCategory) => void,
  selectedCategory: OrganisationalSummaryCategory,
  currency: PaymentCurrencyType,
  onCurrencyChange: (currency: PaymentCurrencyType) => void
}

interface TrendRate {
  title: string,
  description: string,
  value: string
}

const categories = [
  {label: "admin.reporting.orgSummary.categories.main",
    id: "category_all",
    value: OrganisationalSummaryCategory.Main, icon: IconTypes.all},
  {label: "admin.reporting.orgSummary.categories.perks",
    id: "category_perks",
    value: OrganisationalSummaryCategory.Perks, icon: IconTypes.perks},
  {label: "admin.reporting.orgSummary.categories.flexi",
    id: "category_flexiPerks",
    value: OrganisationalSummaryCategory.FlexiPerks, icon: IconTypes.flexi},
  {label: "admin.reporting.orgSummary.categories.celebrations",
    id: "category_celebrations",
    value: OrganisationalSummaryCategory.Celebrations, icon: IconTypes.celebration},
  {label: "admin.reporting.orgSummary.categories.wellness",
    id: "category_wellness",
    value: OrganisationalSummaryCategory.Wellness, icon: IconTypes.wellness}
]

class Categories extends PureComponent<Props> {
  render(){
    const {formatMessage, onChange, selectedCategory, currency, onCurrencyChange} = this.props

    return (
      <Flex justifyContent="flex-end" alignItems="center" marginBottom={4} gap={theme.spacing.oneAndHalf}>
        <Flex justifyContent="flex-end" gap={theme.spacing.oneAndHalf}>
          {categories.map((category) =>
            <FilterChipToggle
              id={category.id}
              isToggled={selectedCategory === category.value}
              onClick={() => onChange(category.value)}
              icon={category?.icon}>
              {formatMessage({id: category.label})}
            </FilterChipToggle>
          )}
        </Flex>
        <Divider />
        <Row>
          <Select
            id="adminSection_organisationalSummary_currency"
            isClearable={false}
            value={currency}
            options={[
              {value: PaymentCurrencyType.Gbp, label: PaymentCurrencyType.Gbp},
              {value: PaymentCurrencyType.Aud, label: PaymentCurrencyType.Aud}
            ]}
            onChange={onCurrencyChange} />
        </Row>
      </Flex>

    )
  }
}

export default injectIntl(Categories)
